import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { AddRemoveEnum, Ratio } from 'app/shared';

@Component({
    selector: 'app-month-selector',
    templateUrl: './month-selector.component.html',
    styleUrls: ['./month-selector.component.scss'],
    standalone: false
})
export class MonthSelectorComponent implements OnInit {
  @Output() monthChanged = new EventEmitter<Date>();
  @Output() monthIntialized = new EventEmitter<Date>();

  @Input() ratios: Array<Ratio>;

  public isNextMonthEnabled = false;
  public initialDate: Date;
  public selectedDate: Date;

  public addRemoveEnum = AddRemoveEnum;

  private readonly toastText = `La prévision du futur n'est pas encore possible avec Ploutos 😉`;
  constructor(private toastController: ToastController) {}

  ngOnInit() {
    // Initialize values
    this.initialDate = new Date();
    this.selectedDate = new Date(this.initialDate.valueOf());

    // Emit initialized value
    this.monthIntialized.emit(this.selectedDate);
  }

  /**
   * Function to add or remove month from date
   * NB : cannot go in future
   * NB2 : no limit to the past
   *
   * @param are The add / remove enum
   */
  public changeMonth(are: AddRemoveEnum): void {
    switch (are) {
      case AddRemoveEnum.add:
        if (this.selectedDate.valueOf() === this.initialDate.valueOf()) {
          // Display a toast
          this.displayToast();
          return;
        }
        this.selectedDate = new Date(this.alterSelectedDate(1).valueOf());
        this.monthChanged.emit(this.selectedDate);
        break;
      case AddRemoveEnum.remove:
        this.selectedDate = new Date(this.alterSelectedDate(-1).valueOf());
        this.monthChanged.emit(this.selectedDate);
        break;
    }
  }

  //#region Private(s)
  /**
   * Function that uses zero based set month from a date
   *
   * @param monthToAddOrSubstract The number of month to add or substract to the selected date
   */
  private alterSelectedDate = (monthToAddOrSubstract: number) => {
    this.selectedDate.setMonth(
      this.selectedDate.getMonth() + monthToAddOrSubstract
    );
    return this.selectedDate;
  };

  /**
   * Display a toast at botom saying the message content
   */
  private displayToast = async () => {
    const toast = await this.toastController.create({
      message: this.toastText,
      duration: 800,
      position: 'bottom',
      color: 'warning',
    });

    await toast.present();
  };
  //#endregion
}
